import { Routes } from '@angular/router';

export const projectsanddocumentsroutes: Routes = [
  {
    path: 'circular',
    loadChildren: () => import('./circular/circular.module').then(m => m.CircularModule), data: { animation: 'circular', roles: ['MANAGER', 'INTERNOS', 'INTERNO_NO_CONTABLE', 'EMPLEADO', 'ADMINISTRADOR'] }
  },
  {
    path: 'manual',
    loadChildren: () => import('./manual/manual.module').then(m => m.ManualModule), data: { animation: 'manual', roles: ['MANAGER', 'INTERNOS', 'INTERNO_NO_CONTABLE', 'EMPLEADO', 'ADMINISTRADOR'] }
  },
  {
    path: 'newsletter',
    loadChildren: () => import('./newsletter/newsletter.module').then(m => m.NewsletterModule), data: { animation: 'newsletter', roles: ['MANAGER', 'INTERNOS', 'INTERNO_NO_CONTABLE', 'EMPLEADO', 'ADMINISTRADOR'] }
  },
  {
    path: 'product',
    loadChildren: () => import('./product/product.module').then(m => m.ProductModule), data: { animation: 'product', roles: ['MANAGER', 'INTERNOS', 'INTERNO_NO_CONTABLE', 'EMPLEADO', 'ADMINISTRADOR'] }
  },
  {
    path: 'project',
    loadChildren: () => import('./project/project.module').then(m => m.ProjectModule), data: { animation: 'project', roles: ['MANAGER', 'INTERNOS', 'INTERNO_NO_CONTABLE', 'EMPLEADO', 'ADMINISTRADOR'] }
  }
]
